var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEmailIcon = function SvgEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons in View"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.88889 8.33322L12 12.5361L18.1111 8.33322M23 18.111V5.88878C23 5.24047 22.7425 4.61872 22.284 4.1603C21.8256 3.70187 21.2039 3.44434 20.5556 3.44434H3.44444C2.79614 3.44434 2.17438 3.70187 1.71596 4.1603C1.25754 4.61872 1 5.24047 1 5.88878V18.111C1 18.7593 1.25754 19.3811 1.71596 19.8395C2.17438 20.2979 2.79614 20.5554 3.44444 20.5554H20.5556C21.2039 20.5554 21.8256 20.2979 22.284 19.8395C22.7425 19.3811 23 18.7593 23 18.111Z",
    stroke: "#737373",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-icon.62365e10.svg";
export { ForwardRef as ReactComponent };